var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.75C4.45312 0.75 0.75 4.45312 0.75 9C0.75 13.5469 4.45312 17.25 9 17.25C13.5469 17.25 17.25 13.5469 17.25 9C17.25 4.45312 13.5469 0.75 9 0.75ZM9 2.25C12.7354 2.25 15.75 5.26465 15.75 9C15.75 12.7354 12.7354 15.75 9 15.75C5.26465 15.75 2.25 12.7354 2.25 9C2.25 5.26465 5.26465 2.25 9 2.25ZM13.0547 6.14062L8.25 10.9219L5.78906 8.46094L4.71094 9.53906L7.71094 12.5391L8.25 13.0547L8.78906 12.5391L14.1094 7.19531L13.0547 6.14062Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.eaee151e2e85c2e5f977142c03aac810.svg";
export { ForwardRef as ReactComponent };